module.exports = __webpack_public_path__ + "img/yangImg2.0e3db58c.jpg";